module.exports = __webpack_public_path__ + "images/emoji/swimmer.b3a2c66200dbb790e9bd.png";